import { derived, get, writable } from "svelte/store";
import translations from "./translations";
import "date-fns/locale";
export const defaultLocale = "de";
export const locale = writable(defaultLocale);
export const locales = Object.keys(translations);
var storedLocale = localStorage.getItem("locale");
if (storedLocale && locales.includes(storedLocale)) {
    locale.set(storedLocale);
}
function getLocale() {
    const locale = localStorage.getItem("locale");
    if (locale && locales.includes(locale)) {
        return locale;
    }
    return defaultLocale;
}
export function getLocaleByInt() {
    const locale = getLocale();
    switch (locale) {
        case "de":
            return 0;
        case "en":
            return 1;
        default:
            return 0;
    }
}
function translate(locale, key, vars) {
    // Let's throw some errors if we're trying to use keys/locales that don't exist.
    // We could improve this by using Typescript and/or fallback values.
    if (!key) {
        translationError("no key provided to $t()");
        return "";
    }
    if (!locale) {
        translationError(`no translation for locale ${locale} and key "${key}"`);
        return "";
    }
    // Grab the translation from the translations object.
    let text = translations[locale][key];
    // no en translation, fallback to default locale (DE)
    if (!text)
        text = translations[defaultLocale][key];
    if (text == null) {
        translationError(`no translation for key "${key}"`);
        return "";
    }
    text = text.toString();
    if (typeof text === "string")
        return stringFormat(text, ...vars);
}
export const t = derived(locale, ($locale) => {
    return (...keyAndVars) => {
        if (keyAndVars.length === 0) {
            translationError("no key provided to $t()");
            return "";
        }
        const key = keyAndVars[0];
        const vars = keyAndVars.slice(1);
        return translate($locale, key, vars);
    };
});
function translationError(errormsg) {
    if (["localhost", "0.0.0.0"].some(lhost => window.location.host.includes(lhost))) {
        alert(errormsg);
        throw new Error(errormsg);
    }
    console.error(errormsg);
}
export const setLocale = (newLocale) => {
    if (newLocale == get(locale))
        return;
    locale.set(newLocale);
    localStorage.setItem("locale", newLocale);
    window.location.reload();
};
export const swapLocale = () => {
    const currentLocale = get(locale);
    setLocale(currentLocale === "en" ? "de" : "en");
};
const stringFormatRegex = /{{\w+}}/g;
function stringFormat(template, ...args) {
    const matches = template.match(stringFormatRegex);
    if (!matches)
        return template;
    if (args.length !== matches.length) {
        translationError(`wrong number of arguments for stringFormat
            - template: ${template}
            - args: ${args.length == 0 ? "none provided" : args.join(", ")} (${matches.length} expected)
            - matches: ${matches.join(", ")}
        `);
        return "";
    }
    let i = 0;
    return template.replace(stringFormatRegex, (match) => {
        const replacement = typeof args[i] !== 'undefined' ? args[i] : match;
        i++;
        return replacement;
    });
}
